const DOCUMENT = 'HOLIDAY_PRICING_';

const actions = {
  LOAD_HOLIDAYS_REQUEST: DOCUMENT + 'LOAD_HOLIDAYS_REQUEST',
  LOAD_HOLIDAYS_SUCCESS: DOCUMENT + 'LOAD_HOLIDAYS_SUCCESS',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  LOAD_DISTRICTS_REQUEST: DOCUMENT + 'LOAD_DISTRICTS_REQUEST',
  LOAD_DISTRICTS_SUCCESS: DOCUMENT + 'LOAD_DISTRICTS_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  TOGGLE_HOLIDAY_PRICING_MODAL: DOCUMENT + 'TOGGLE_HOLIDAY_PRICING_MODAL',
  ADD_FORM_ITEM: DOCUMENT + 'ADD_FORM_ITEM',
  REMOVE_FORM_ITEM: DOCUMENT + 'REMOVE_FORM_ITEM',
  CREATE_HOLIDAY_PRICING_REQUEST: DOCUMENT + 'CREATE_HOLIDAY_PRICING_REQUEST',
  CREATE_HOLIDAY_PRICING_SUCCESS: DOCUMENT + 'CREATE_HOLIDAY_PRICING_SUCCESS',
  CREATE_HOLIDAY_PRICING_ERROR: DOCUMENT + 'CREATE_HOLIDAY_PRICING_ERROR',
  SET_SELECTED_DATE: DOCUMENT + 'SET_SELECTED_DATE',
  CLEAR_MODAL_DATA: DOCUMENT + 'CLEAR_MODAL_DATA',
  SET_SELECTED_RECORD: DOCUMENT + 'SET_SELECTED_RECORD',
  UPDATE_HOLIDAY_PRICING_REQUEST: DOCUMENT + 'UPDATE_HOLIDAY_PRICING_REQUEST',
  UPDATE_HOLIDAY_PRICING_SUCCESS: DOCUMENT + 'UPDATE_HOLIDAY_PRICING_SUCCESS',
  UPDATE_HOLIDAY_PRICING_ERROR: DOCUMENT + 'UPDATE_HOLIDAY_PRICING_ERROR',
  REMOVE_HOLIDAY_PRICING_REQUEST: DOCUMENT + 'REMOVE_HOLIDAY_PRICING_REQUEST',
  REMOVE_HOLIDAY_PRICING_SUCCESS: DOCUMENT + 'REMOVE_HOLIDAY_PRICING_SUCCESS',
  REMOVE_HOLIDAY_PRICING_ERROR: DOCUMENT + 'REMOVE_HOLIDAY_PRICING_ERROR',
  TOGGLE_CONFIRM_REMOVAL_MODAL: DOCUMENT + 'TOGGLE_CONFIRM_REMOVAL_MODAL',
  SET_LOADING_INDEX: DOCUMENT + 'SET_LOADING_INDEX',

  setLoadingIndex: data => ({
    type: actions.SET_LOADING_INDEX,
    payload: data,
  }),

  removeHolidayPricingRequest: data => ({
    type: actions.REMOVE_HOLIDAY_PRICING_REQUEST,
    payload: data,
  }),

  removeHolidayPricingSuccess: () => ({
    type: actions.REMOVE_HOLIDAY_PRICING_SUCCESS,
  }),

  removeHolidayPricingError: () => ({
    type: actions.REMOVE_HOLIDAY_PRICING_ERROR,
  }),

  updateHolidayPricingRequest: data => ({
    type: actions.UPDATE_HOLIDAY_PRICING_REQUEST,
    payload: data,
  }),

  updateHolidayPricingSuccess: () => ({
    type: actions.UPDATE_HOLIDAY_PRICING_SUCCESS,
  }),

  updateHolidayPricingError: () => ({
    type: actions.UPDATE_HOLIDAY_PRICING_ERROR,
  }),

  setSelectedRecord: data => ({
    type: actions.SET_SELECTED_RECORD,
    payload: data,
  }),

  clearModalData: () => ({
    type: actions.CLEAR_MODAL_DATA,
  }),

  setSelectedDate: data => ({
    type: actions.SET_SELECTED_DATE,
    payload: data,
  }),

  createHolidayPricingRequest: data => ({
    type: actions.CREATE_HOLIDAY_PRICING_REQUEST,
    payload: data,
  }),

  createHolidayPricingSuccess: () => ({
    type: actions.CREATE_HOLIDAY_PRICING_SUCCESS,
  }),

  createHolidayPricingError: () => ({
    type: actions.CREATE_HOLIDAY_PRICING_ERROR,
  }),

  addFormItem: data => ({
    type: actions.ADD_FORM_ITEM,
    payload: data,
  }),

  removeFormItem: data => ({
    type: actions.REMOVE_FORM_ITEM,
    payload: data,
  }),

  loadHolidaysRequest: () => ({
    type: actions.LOAD_HOLIDAYS_REQUEST,
  }),

  loadHolidaysSuccess: data => ({
    type: actions.LOAD_HOLIDAYS_SUCCESS,
    payload: data,
  }),

  toggleHolidayPricingModal: data => ({
    type: actions.TOGGLE_HOLIDAY_PRICING_MODAL,
    payload: data,
  }),

  toggleConfirmRemovalModal: data => ({
    type: actions.TOGGLE_CONFIRM_REMOVAL_MODAL,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  loadDistrictsRequest: () => ({
    type: actions.LOAD_DISTRICTS_REQUEST,
  }),

  loadDistrictsSuccess: data => ({
    type: actions.LOAD_DISTRICTS_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
